import api from './api';
import type { ApiResponse } from '../features/menu/types';

export interface UserProfile {
  Id: number;
  Name: string;
  Login: string;
  Initials: string;
  ProfileUrl?: string;
  ProfileFormKey?: string;
  CanSeeSensitiveDataPassword: boolean;
  CanShowProfileNavigation: boolean;
  CanSeeNotifications: boolean;
  VersionLabel?: string;
}

export const userService = {
  getCurrentUser: () =>
    api.get<ApiResponse<UserProfile> | UserProfile>('/umbraco/api/UserManagment/GetCurrentUser'),
};
